import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import {
  getCompressedImage,
  getdepletionStatus,
  getServiceStatus,
} from '../api/apiService';

export const validateFile = (file, name) => {
  let error = '';
  const extension = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
  if (
    extension !== 'jpg' &&
    extension !== 'gif' &&
    extension !== 'png' &&
    extension !== 'bmp' &&
    extension !== 'jpeg'
  ) {
    error = 'Wrong file type';
  } else if (file.size > 5242880) {
    error = 'File size cannot exceed more than 5MB';
  }

  return error;
};

export const serviceHealth = async () => {
  try {
    const status = await getServiceStatus();
    if (status === 'UP') return true;
    return false;
  } catch (err) {
    toast.error(err.message, {
      position: toast.POSITION.BOTTOM_LEFT,
    });
    return false;
  }
};

export const shrinkFile = async (file, name) => {
  const formData = new FormData();
  formData.append('file', file);
  let fileObj = null;

  try {
    const count = await getdepletionStatus();
    if (+count < 500) {
      const compressedData = await getCompressedImage(formData);
      const compressedFile = new File([compressedData], name);
      fileObj = {
        file: compressedFile,
        name: name + uuidv4(),
      };
    }
    return fileObj;
  } catch (err) {
    throw new Error(err.message);
  }
};

export const shrinkFiles = async (files, name) => {
  const promises = [];
  let fileObjs = [];
  for (const file of files) {
    const formData = new FormData();
    formData.append('file', file);

    promises.push(
      getdepletionStatus()
        .then((count) => {
          if (+count < 500) return getCompressedImage(formData);
        })
        .then((compressedData) => {
          const compressedFile = new File([compressedData], name);
          const fileObj = {
            file: compressedFile,
            name: name + uuidv4(),
          };
          return fileObj;
        })
    );
  }

  fileObjs = await Promise.all(promises);
  return fileObjs;
};
